import createDecorator from 'final-form-calculate';
import { get, includes } from 'lodash';

import { ASSET_TYPE, FIELD_PATHS, FIELD_VALUES, VISIT_CONTACT_TYPE } from '@funnels/constants';
import { Liability } from '@funnels/types';

interface FieldsToUpdate {
  [key: string]: boolean;
}

const decorator: any = createDecorator(
  {
    field: /applicants\[\d+\].title/,
    updates: (value, name, allValues) => {
      const genderField = name.replace('title', 'gender');
      let gender;
      if (value === FIELD_VALUES.MR) {
        gender = FIELD_VALUES.MALE;
      } else if (value === FIELD_VALUES.MISS || value === FIELD_VALUES.MRS || value === FIELD_VALUES.MS) {
        gender = FIELD_VALUES.FEMALE;
      } else {
        gender = FIELD_VALUES.UNDISCLOSED;
      }
      return {
        [genderField]: gender,
      };
    },
  },
  {
    field: /assets\[\d+\].percentOwned/,
    updates: (value, name, allValues) => {
      const currentAssetIndex = (name.match(/\d+/) || []).map(Number)[0];
      const isPropertyOrVehicle = includes(
        [ASSET_TYPE.PROPERTY, ASSET_TYPE.VEHICLE],
        get(allValues, FIELD_PATHS.ASSET_TYPE(currentAssetIndex))
      );
      const fieldsToUpdate: FieldsToUpdate = {};
      if (isPropertyOrVehicle) {
        const assetClientID = get(allValues, FIELD_PATHS.ASSET_CLIENT_ID(currentAssetIndex));
        const assetOwnership = get(allValues, FIELD_PATHS.ASSET_PERCENT_OWNED(currentAssetIndex));
        get(allValues, FIELD_PATHS.LIABILITIES(), []).forEach((liability: Liability, index: number) => {
          const liabilityAssetClientId = get({ liabilities: [liability] }, FIELD_PATHS.LIABILITY_ASSET_CLIENT_ID(0));
          if (includes(liabilityAssetClientId, assetClientID)) {
            fieldsToUpdate[FIELD_PATHS.LIABILITY_PERCENT_OWNED(index)] = assetOwnership;
          }
        });
      }
      return fieldsToUpdate;
    },
  }
);

export default decorator;
